module.exports = __webpack_public_path__ + "static/media/logo.139d3ea9.svg";